



















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { perRoadStore } from '@/store/store';
import { UnitSystem } from '@/interfaces/units';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import {
  ILayerPerformanceCriteriaImperial,
  ILayerPerformanceCriteriaMetric, LayerPerformanceCriteriaLocation,
} from '@/modules/perRoad/interfaces/perRoad';
import PrHorizontalStrainMeDesignPlot
  from '@/modules/perRoad/views/components/criteria/plots/PrHorizontalStrainMeDesignPlot.vue';


const echarts = require('echarts');

@Component({
  components: {
    PrHorizontalStrainMeDesignPlot,
    PxNumberInput,
  },
})
export default class ConventionalMeDesignHorizontal extends Vue {
  @Prop() performanceCriteria!: ILayerPerformanceCriteriaImperial | ILayerPerformanceCriteriaMetric

  @Prop() id!: string;

  @Prop() validations!: any;

  plotKey = 0;
  
  get layerLocationOptions() {
    return Object.entries(LayerPerformanceCriteriaLocation).map((k, v) => ({ text: k[1], value: k[1] }));
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  get strainUnits() {
    return this.unitSystemIsImperial ? 'x 10<sup>-6</sup>&nbsp&nbspin/in' : 'x 10<sup>-6</sup>&nbsp&nbspcm/cm';
  }

  get transferFunctionNf() {
    let Nf = 0;
    if (this.performanceCriteria.useTransferFunction) {
      const k1 = this.performanceCriteria.k1 || 0;
      const k2 = this.performanceCriteria.k2 || 0;
      const eps_t = this.performanceCriteria.strainThreshold_ustrain || 0;

      Nf = k1 * (1 / Math.abs(eps_t * 10 ** (-6))) ** k2;
    }
    return Nf;
  }


  sync() {
    this.$emit('sync');
    this.plotKey += 1;
  }

  mounted() {
  }

  updated() {
  }
}
